import { useTransition } from "react";

export type FeedbackToggleProps = {
  feedbackEnabled: boolean;
  onChange: (next: boolean) => void;
};

/**
 * In-session toggle for live feedback. Compact Aan/Uit segmented pill.
 */
export function FeedbackToggle({ feedbackEnabled, onChange }: FeedbackToggleProps) {
  const [pending, startTransition] = useTransition();

  function set(next: boolean) {
    if (next === feedbackEnabled || pending) return;
    onChange(next);
    startTransition(() => {});
  }

  const segmentBase =
    "inline-flex h-8 sm:h-10 items-center rounded-full px-3 sm:px-4 text-xs sm:text-sm focus-visible:[border-radius:9999px] transition-colors";
  const segmentActive = `${segmentBase} bg-[var(--accent)] font-semibold text-[var(--bg)]`;
  const segmentIdle = `${segmentBase} text-[var(--ink-muted)] hover:bg-[var(--accent-soft)] hover:text-[var(--ink)]`;

  return (
    <div
      role="group"
      aria-label="Feedback tussendoor"
      className="inline-flex items-center rounded-full border border-[var(--border)] bg-[var(--panel-soft)] p-1"
    >
      <button
        type="button"
        onClick={() => set(true)}
        aria-pressed={feedbackEnabled}
        className={feedbackEnabled ? segmentActive : segmentIdle}
      >
        Aan
      </button>
      <button
        type="button"
        onClick={() => set(false)}
        aria-pressed={!feedbackEnabled}
        className={!feedbackEnabled ? segmentActive : segmentIdle}
      >
        Uit
      </button>
    </div>
  );
}
